var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3939_37417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1882 4.51074H3.7425C3.37412 4.51074 3.02082 4.65708 2.76034 4.91757C2.49985 5.17805 2.35352 5.53134 2.35352 5.89972V19.7895C2.35352 20.1579 2.49985 20.5112 2.76034 20.7717C3.02082 21.0322 3.37412 21.1785 3.7425 21.1785H23.1882C23.5566 21.1785 23.9099 21.0322 24.1704 20.7717C24.4309 20.5112 24.5772 20.1579 24.5772 19.7895V5.89972C24.5772 5.53134 24.4309 5.17805 24.1704 4.91757C23.9099 4.65708 23.5566 4.51074 23.1882 4.51074ZM22.1187 19.7895H4.89535L9.75679 14.7614L8.75672 13.7961L3.7425 18.9839V6.95535L12.375 15.5462C12.6353 15.8049 12.9873 15.9501 13.3543 15.9501C13.7212 15.9501 14.0732 15.8049 14.3335 15.5462L23.1882 6.74006V18.8936L18.0768 13.7822L17.0976 14.7614L22.1187 19.7895ZM4.65228 5.89972H22.0632L13.3543 14.56L4.65228 5.89972Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3939_37417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0017,
    height: 25.0017,
    fill: "white",
    transform: "translate(0.966797 0.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c434f56f78ec9887f006a1321c3e315b.svg";
export { ForwardRef as ReactComponent };